<template>
  <div>
    <modify-currency-popup
      :show="ModifyPopup"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </modify-currency-popup>
    <assign-itemcode-popup
      :show="ItemCodePopup"
      :model="model"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </assign-itemcode-popup>
    <refrence-info-popup
      :show="RefrencePopup"
      :editModel="model.sellerReference"
      :model="model"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </refrence-info-popup>
    <shipment-info-popup
      :show="ShipmentPopup"
      :editModel="model.shipmentInfo"
      :model="model"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </shipment-info-popup>
    <assign-itemcode-popup
      :show="ItemCodePopup"
      :model="model"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </assign-itemcode-popup>
    <assign-weight-popup
      :show="WeightPopup"
      :model="model"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </assign-weight-popup>
    <div class="flex justify-end w-full ml-4 mb-10">
      <vs-button
        type="filled"
        color="danger"
        v-has-permission="'GotoReject'"
        @click.prevent="reject"
      >
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        v-has-permission="'GotoConfirm'"
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Confirm") }}</span>
      </vs-button>
    </div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">
                    {{ $t("RequesterName") }}
                  </th>
                  <th style="width: 14%" class="border-0">
                    {{ $t("RequesterUsername") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Departman") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Supplier") }}
                  </th>

                  <th style="width: 10%" class="border-0">
                    {{ $t("CurrencyType") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("CurrencyRate") }}
                  </th>

                  <th style="width: 13%" class="border-0">
                    {{ $t("DeliveryDate") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("CreateOn") }}
                  </th>
                  <th style="width: 40%" class="border-0">
                    {{ $t("Description") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%" class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>

                  <td style="width: 8%" class="border-0">
                    <div v-if="model.currencyInfo">
                      {{
                        model.currencyInfo.currencyType === 1
                          ? "ریال"
                          : model.currencyInfo.currencyType === 2
                          ? "دلار"
                          : model.currencyInfo.currencyType === 3
                          ? "درهم"
                          : "-"
                      }}
                    </div>
                  </td>
                  <td style="width: 8%" class="border-0">
                    {{ model.currencyInfo ? model.currencyInfo.rate : "-" }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <td style="width: 33%" class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="flex justify-between w-full mt-5">
          <div>
            <h3>
              {{ $t("PreInvoice") }}
            </h3>
          </div>
          <div class="ml-1">
            <vs-button
              type="filled"
              id="info-btn"
              @click.prevent="editShipmentInfo"
            >
              <span> {{ $t("ShipmentInfo") }}</span>
            </vs-button>
            <vs-button
              class="mr-5"
              id="info-btn"
              v-has-permission="'UpdateSellerReference'"
              type="filled"
              @click.prevent="editRefrence"
            >
              <span> {{ $t("RefrenceInfo") }}</span>
            </vs-button>

            <vs-button
              class="mr-5"
              id="info-btn"
              v-has-permission="'UpdateItemCodeOfInvoiceItems'"
              type="filled"
              @click.prevent="editItemCode"
            >
              <span> {{ $t("EditItemCode") }}</span>
            </vs-button>
            <vs-button
              class="mr-5"
              id="info-btn"
              v-has-permission="'UpdateWeightsOffPurchasesInvoiceItems'"
              type="filled"
              @click.prevent="editWeight"
            >
              <span> {{ $t("EditWeight") }}</span>
            </vs-button>
            <vs-button
              @click="editCurrency"
              class="ml-1 mr-5"
              type="filled"
              id="currency-btn"
              v-has-permission="'UpdateCurrencyInfoCommand'"
            >
              <span> {{ $t("CurrencyType") }}</span>
            </vs-button>
            <router-link
              v-has-permission="'UpdateDeductionAndIncreasesOfPurchaseInvoice'"
              class="mr-5"
              :to="
                '/ProcurementManagement/PurchaseInvoice/DeductionAndIncrease' +
                '/' +
                pOId
              "
            >
              <vs-button type="filled" id="deduction-btn">
                <span> {{ $t("DeductionAndIncrease") }}</span>
              </vs-button>
            </router-link>
          </div>
        </div>
        <div class="flex gap-3">
                  <div class="flex my-5" v-has-permission="''">
          <label class="custom-file-upload flex">
            <input
              type="file"
              id="file"
              ref="purchaseRequestElement"
              v-on:change="handlepurchaseRequestSelection()"
            />
            <div class="flex gap-2 items-center">
              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              <span>{{ $t("UploadItemCode") }}</span>
            </div>
            <span v-if="selectedPurchaseRequestFileName" class="file-name">{{
              selectedPurchaseRequestFileName
            }}</span>
          </label>
          <vs-button
            @click="uploadPackage()"
            class="bg_m_green float-right"
            v-if="purchaseRequestSelected"
            :disabled="serialUploadButtonDisabled"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("Submit") }}
          </vs-button>
        </div>
        <!-- UpdateWeightsOfPurchaseInvoiceItemsWithExcelFile -->
        <div class="flex my-5" v-has-permission="''">
          <label class="custom-file-upload flex">
            <input
              type="file"
              id="file"
              ref="weightElement"
              v-on:change="handleWeightSelection()"
            />
            <div class="flex gap-2 items-center">
              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              <span>{{ $t("UploadWieght") }}</span>
            </div>
            <span v-if="selectedWeightFileName" class="file-name">{{
              selectedWeightFileName
            }}</span>
          </label>
          <vs-button
            @click="uploadWeight()"
            class="bg_m_green float-right"
            v-if="weightSelected"
            :disabled="serialUploadButtonDisabled"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("Submit") }}
          </vs-button>
        </div>
        </div>

        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.purchaseItems && model.purchaseItems.length > 0"
          >
            <vs-table
              :data="model.purchaseItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 20%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">
                  {{ $t("AmountSourceCurrencyWithDeduction") }}
                </th>

                <!-- <th style="width: 10%">{{ $t("EffectiveAmount") }}</th> -->
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseInvoiceProductInfo.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseInvoiceProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td>
                    {{
                      row.purchaseInvoiceProductInfo
                        ? row.purchaseInvoiceProductInfo.itemCode
                        : "-"
                    }}
                  </vs-td>

                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <vs-td>
                    {{ formatPrice(row.unitPrice) }}
                  </vs-td>
                  <vs-td>
                    {{
                      row.unitPriceAfterDeductionAndIncrease
                        ? formatPrice(row.unitPriceAfterDeductionAndIncrease)
                        : "-"
                    }}
                  </vs-td>
                  <!-- <vs-td style="direction: ltr;">
                    {{ formatPrice(row.effectiveAmount) }}
                  </vs-td> -->
                  <vs-td>
                    {{ formatPrice(row.amount) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end mt-3 w-full ml-5">
            <table class="basic-tbl w-1/5 total" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%">{{ $t("TotalAmount") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.totalAmount ? formatPrice(model.totalAmount) : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        model.purchaseInvoiceDeductionAndIncreases &&
        model.purchaseInvoiceDeductionAndIncreases.length > 0
      "
      class="vx-card mt-5"
    >
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("DeductionAndIncrease") }}
        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <vs-table
              :data="model.purchaseInvoiceDeductionAndIncreases"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">
                  {{ $t("DeductionAndIncreaseType") }}
                </th>
                <th style="width: 10%">{{ $t("ToleranceType") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 10%">{{ $t("Description") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>{{ index + 1 }}</vs-td>
                  <vs-td style="width: 10%">
                    <div>
                      {{
                        row.deductionAndIncreaseType &&
                        row.deductionAndIncreaseType === 1
                          ? "کسر"
                          : "اضافه"
                      }}
                    </div>
                  </vs-td>
                  <vs-td style="width: 10%">
                    <div>
                      {{
                        row.toleranceType && row.toleranceType === 1
                          ? "درصدی"
                          : "مقداری"
                      }}
                    </div>
                  </vs-td>

                  <vs-td style="width: 10%">
                    <div>
                      {{ row.amount ? formatPrice(row.amount) : "-" }}
                    </div>
                  </vs-td>
                  <vs-td style="width: 30%">
                    <div>
                      {{ row.description ? row.description : "-" }}
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";
import ModifyCurrencyPopup from "./ModifyCurrencyPopup.vue";
import AssignItemcodePopup from "./AssignItemcodePopup.vue";
import AssignWeightPopup from "./AssignWeightPopup.vue";
import RefrenceInfoPopup from "./RefrenceInfoPopup.vue";
import ShipmentInfoPopup from "./ShipmentInfoPopup.vue";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    ModifyCurrencyPopup,
    AssignItemcodePopup,
    ShipmentInfoPopup,
    RefrenceInfoPopup,
    AssignWeightPopup,
  },
  data() {
    return {
      allUnits: [],
      ModifyPopup: false,
      ItemCodePopup: false,
      WeightPopup: false,
      RefrencePopup: false,
      ShipmentPopup: false,
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: 0,
      unit: {},
      editItemCodeClicked: false,
      purchaseRequestElement: null,
      selectedPurchaseRequestFileName: "",
      purchaseRequestSelected: false,
      weightElement: null,
      selectedWeightFileName: "",
      weightSelected: false,
      serialUploadButtonDisabled: false,
      pOId: -1,
    };
  },

  mounted() {
    this.load();
    this.pOId = this.$route.params.id;
  },
  methods: {
    ...mapActions({
      fetchPurchaseInvoice: "purchaseInvoice/fetchPurchaseInvoice",
      acceptPurchaseInvoice: "purchaseInvoice/acceptPurchaseInvoice",
      rejectPurchaseInvoice: "purchaseInvoice/rejectPurchaseInvoice",
      updatePurchaseOrderItemCode: "excel/updatePurchaseOrderItemCode",
      updateWeight: "excel/updateWeight",
    }),
    handlepurchaseRequestSelection() {
      this.purchaseRequestElement = this.$refs.purchaseRequestElement.files[0];
      this.selectedPurchaseRequestFileName = this.purchaseRequestElement.name;
      this.purchaseRequestSelected = true;
    },
    uploadPackage() {
      this.serialUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.purchaseRequestElement);
      this.updatePurchaseOrderItemCode({
        file: formData,
        id: this.pOId,
      })
        .then(() => {
              this.load();

        })
        .finally(() => {
          this.serialUploadButtonDisabled = false;
          this.onFileUploadSuccess();
        });
    },
    handleWeightSelection() {
      this.weightElement = this.$refs.weightElement.files[0];
      this.selectedWeightFileName = this.weightElement.name;
      this.weightSelected = true;
    },
    uploadWeight() {
      this.serialUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.weightElement);
      this.updateWeight({
        file: formData,
        id: this.pOId,
      })
        .then(() => {
              this.load();

        })
        .finally(() => {
          this.serialUploadButtonDisabled = false;
          this.onFileUploadSuccess();
        });
    },
    onFileUploadSuccess() {
      this.$refs.purchaseRequestElement.value = null;
      this.$refs.weightElement.value = null;
      this.$refs.serialFileElement.value = null;
      this.serialFileSelected = false;
      this.purchaseRequestSelected = false;
      this.selectedPurchaseRequestFileName = "";
      this.weightSelected = false;
      this.selectedWeightFileName = "";
    },
    load() {
      var id = this.$route.params.id;
      this.fetchPurchaseInvoice(id).then((r) => {
        this.model = r;
      });
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
      this.ItemCodePopup = false;
      this.WeightPopup = false;
      this.RefrencePopup = false;
      this.ShipmentPopup = false;
      this.load();
    },
    onfinish() {
      this.closeModifyPopup();
    },
    editCurrency() {
      this.ModifyPopup = true;
    },
    editRefrence() {
      this.RefrencePopup = true;
    },
    editShipmentInfo() {
      this.ShipmentPopup = true;
    },
    editItemCode() {
      // this.editItemCodeClicked = !this.editItemCodeClicked;
      this.ItemCodePopup = true;
    },
    editWeight() {
      // this.editItemCodeClicked = !this.editItemCodeClicked;
      this.WeightPopup = true;
    },

    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این درخواست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectPurchaseInvoice({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    showRefrenceInfo() {},
    showShipmentInfo() {},
    accept() {
      this.acceptPurchaseInvoice({ id: this.model.id }).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "سفارش خرید مورد نظر تایید شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
<style>
#deduction-btn {
  background: #836dd8 !important;
}
#currency-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
#info-btn {
  background: #4a7 !important;
}
body[dir="rtl"] table thead th {
  position: static;
}
.total thead {
  border: 1px solid;
}
#colored-table thead tr th {
  color: white;
}
.basic-tbl {
  border: 0 !important;
  & tbody {
    & tr {
      & td {
        border-bottom: 0.2px solid #696161 !important;
      }
    }
  }
}
.custom-file-upload {
  border: 1px solid #ccc;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
input[type="file"] {
  display: none;
}
</style>
